export const NetworkIconV2 = ({ url, className }: { url: string | undefined; className?: string }) => {
  return <img className={`rounded-[6px] ${className}`} src={url} />
}
